document.addEventListener('DOMContentLoaded', function() {
  const section = document.getElementById('shopify-section-template--27281380409630__hero_rhMed7');
  if (!section) return;
  const video = section.querySelector('video');
  if (!video) return;
  
  const btn = document.createElement('button');
  btn.innerHTML = '🔇';
  btn.style.cssText = 'position:absolute;bottom:16px;right:16px;z-index:10;background:rgba(0,0,0,0.5);border:none;border-radius:50%;width:40px;height:40px;font-size:18px;cursor:pointer;color:white;';
  
  btn.addEventListener('click', function() {
    video.muted = !video.muted;
    btn.innerHTML = video.muted ? '🔇' : '🔊';
  });
  
  const wrapper = video.closest('[style*="position"]') || video.parentElement;
  wrapper.style.position = 'relative';
  wrapper.appendChild(btn);
});